module.exports = __webpack_public_path__ + "static/media/rulesTime.9ad4ecb8.svg";